/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-01-23 13:48:45                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-23 13:58:17                               *
 *****************************************************************************/

/* SUMMARY
  *  workorderExportDescriptor: mapping data/csv
*/

import { formatLocalDate } from "../timezoneUtils";

/**
* workorderExportDescriptor: mapping data/csv
*/
export const workorderExportDescriptor: EasyTech.ExportDescriptor[] = [{
  column: "id",
  columnTranslationKey: "common:export.columns.id",
  // Identifiant technique, demandé pour rapprocher un export d'un autre système. Décoché comme
  // n'importe quelle autre colonne si le lecteur n'en a pas l'usage.
  getter: (e: { id?: string }) => e.id || ""
}, {
  column: "ref",
  columnTranslationKey: "common:ref.label",
  getter: (e: EasyTech.Workorder) => e.ref
}, {
  column: "status",
  columnTranslationKey: "common:status",
  getter: (e: EasyTech.Workorder) => e.status
}, {
  column: "technician",
  columnTranslationKey: "common:technician",
  getter: (e: EasyTech.Workorder) => e.technician ? `${e.technician.firstName} ${e.technician.lastName}` : null
}, {
  column: "planner",
  columnTranslationKey: "common:export.columns.planner",
  getter: (e: EasyTech.Workorder) => e.planner ? `${e.planner.firstName} ${e.planner.lastName}` : null
}, {
  column: "customer",
  columnTranslationKey: "common:customer",
  getter: (e: EasyTech.Workorder) => e.customer ? e.customer.name : null
}, {
  column: "contact",
  columnTranslationKey: "common:contact",
  getter: (e: EasyTech.Workorder) => (e.contacts && e.contacts.length > 0) ? `${e.contacts[0].contact.firstName} ${e.contacts[0].contact.lastName}` : null
}, {
  column: "type",
  columnTranslationKey: "common:type",
  getter: (e: EasyTech.Workorder) => e.type ? e.type.label : null
}, {
  column: "origin",
  columnTranslationKey: "common:origin",
  getter: (e: EasyTech.Workorder) => e.origin ? e.origin.label : null
}, {
  column: "creation_date",
  columnTranslationKey: "common:export.columns.creationDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.created ? formatLocalDate(e.created, realm).split(" ")[0] : "";
  }
}, {
  column: "creation_time",
  columnTranslationKey: "common:export.columns.creationTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.created ? formatLocalDate(e.created, realm).split(" ")[1] : "";
  }
}, {
  column: "schedule_start_date",
  columnTranslationKey: "common:export.columns.scheduleStartDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.schedule && e.schedule.start ?
      formatLocalDate(e.schedule.start, realm).split(" ")[0] : "";
  }
}, {
  column: "schedule_start_time",
  columnTranslationKey: "common:export.columns.scheduleStartTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.schedule && e.schedule.start ?
      formatLocalDate(e.schedule.start, realm).split(" ")[1] : "";
  }
}, {
  column: "schedule_end_date",
  columnTranslationKey: "common:export.columns.scheduleEndDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.schedule && e.schedule.end ?
      formatLocalDate(e.schedule.end, realm).split(" ")[0] : "";
  }
}, {
  column: "schedule_end_time",
  columnTranslationKey: "common:export.columns.scheduleEndTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.schedule && e.schedule.end ?
      formatLocalDate(e.schedule.end, realm).split(" ")[1] : "";
  }
}, {
  column: "real_start_date",
  columnTranslationKey: "common:export.columns.realStartDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.time && e.time.start ?
      formatLocalDate(e.time.start, realm).split(" ")[0] : "";
  }
}, {
  column: "real_start_time",
  columnTranslationKey: "common:export.columns.realStartTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.time && e.time.start ?
      formatLocalDate(e.time.start, realm).split(" ")[1] : "";
  }
}, {
  column: "real_end_date",
  columnTranslationKey: "common:export.columns.realEndDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.time && e.time.end ?
      formatLocalDate(e.time.end, realm).split(" ")[0] : "";
  }
}, {
  column: "real_end_time",
  columnTranslationKey: "common:export.columns.realEndTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.time && e.time.end ?
      formatLocalDate(e.time.end, realm).split(" ")[1] : "";
  }
}, {
  column: "real_duration",
  columnTranslationKey: "common:export.columns.realDuration",
  getter: (e: EasyTech.Workorder) => {
    return e.time?.duration ? `${Math.floor(e.time.duration / 60).toString().padStart(2, "0")}:${(e.time.duration % 60).toString().padStart(2, "0")}` : "";
  }
}, {
  column: "signature_after_date",
  columnTranslationKey: "common:export.columns.signatureDate",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.signatureAfter ?
      formatLocalDate(e.signatureAfter, realm).split(" ")[0].replace(/\//g, "-") : "";
  }
}, {
  column: "signature_after_time",
  columnTranslationKey: "common:export.columns.signatureTime",
  getter: (e: EasyTech.Workorder) => {
    const realm = localStorage.getItem("realm") || "default";
    return e.signatureAfter ?
      formatLocalDate(e.signatureAfter, realm).split(" ")[1] : "";
  }
}, {
  column: "address line 1",
  columnTranslationKey: "common:export.columns.addressLine1",
  getter: (e: EasyTech.Workorder) => e.address?.address || ""
}, {
  column: "address line 2",
  columnTranslationKey: "common:export.columns.addressLine2",
  getter: (e: EasyTech.Workorder) => e.address?.addressCompl || ""
}, {
  column: "zip code",
  columnTranslationKey: "common:export.columns.zipCode",
  getter: (e: EasyTech.Workorder) => e.address?.zipCode || ""
}, {
  column: "city",
  columnTranslationKey: "common:export.columns.city",
  getter: (e: EasyTech.Workorder) => e.address?.city || ""
}, {
  column: "country",
  columnTranslationKey: "common:export.columns.country",
  getter: (e: EasyTech.Workorder) => e.address?.country || ""
}, {
  column: "lat",
  columnTranslationKey: "common:export.columns.latitude",
  getter: (e: EasyTech.Workorder) => e.address?.latitude ?? ""
}, {
  column: "long",
  columnTranslationKey: "common:export.columns.longitude",
  getter: (e: EasyTech.Workorder) => e.address?.longitude ?? ""
}, {
  column: "notes",
  columnTranslationKey: "common:notes",
  getter: (e: EasyTech.Workorder) => {
    if (!e.notes) return "";
    return e.notes.replace(/\r?\n/g, " ").replace(/\r/g, " ");
  }
}];
/***/
